var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-sg wt2-dashboard"},[_c('div',{staticClass:"wt2-dashboard-main-panel"},[_c(_vm.mainPanel,{tag:"component",on:{"filterschange":_vm.triggerAnalyticsFiltersEvent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }